import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useBooking } from "../context/BookingContext";
import { useLang } from "../context/LanguageContext";

const DownPayment = () => {
  const { openBooking } = useBooking();
  const { t } = useLang();

  const programs = [
    { name: "Home Is Possible", stat: "Up to 4%", detail: t("dp.p1d") },
    { name: "Home First", stat: "Up to $15,000", detail: t("dp.p2d") },
    { name: "WISH Grant", stat: "3-to-1 Match", detail: t("dp.p3d") },
  ];

  return (
    <section id="down-payment" data-testid="down-payment-section" className="bg-navy py-24 text-paper lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">{t("dp.eyebrow")}</p>
          <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight sm:text-4xl">
            {t("dp.h2")}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-paper/70">
            {t("dp.body")}
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {programs.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="border border-white/10 bg-white/5 p-8 transition-colors duration-500 hover:border-gold/40"
            >
              <p className="font-serif text-3xl font-bold text-gold">{p.stat}</p>
              <p className="mt-4 font-cinzel text-sm font-bold uppercase tracking-[0.15em]">{p.name}</p>
              <p className="mt-3 text-sm leading-relaxed text-paper/65">{p.detail}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
        >
          <button
            data-testid="downpayment-cta-button"
            onClick={() => openBooking({ service: "down_payment" })}
            className="group flex items-center gap-2 bg-gold px-7 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-navy transition-colors duration-300 hover:bg-paper"
          >
            {t("dp.cta")}
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
          <p className="font-mono text-[11px] text-paper/50">
            {t("dp.note")}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default DownPayment;
